import { baseStats, P } from '../world/player';
/* ============================================================
   數值修正層（M5）
   ============================================================

   **被動不直接改 `P.s`。** 兩層：

     P.base   機體的原始數值（equipMech 時算一次，之後不動）
     P.s      套用所有被動之後的結果（每次持有狀態改變時重算）

   為什麼不直接乘進 `P.s`：

   1. **升級介面要顯示「原始值 → 加成後」**，直接乘的話原始值就不見了
   2. **同一個被動升到 2 級不是「再乘一次當下的值」**。直接乘的寫法在
      「先拿 A 再拿 B 再拿 A」與「先拿 A 兩次再拿 B」之間會得到不同結果 ——
      同樣的 build 因為抽選順序不同而強度不同，那是 bug 不是隨機性
   3. 之後要做「暫時性 buff」「裝備替換」時，只要重算一次就好，不必寫反向操作

   修正的形式只有兩種：`mul`（乘）與 `add`（加）。
   全部的 mul 先連乘、全部的 add 後累加，順序因此與取得順序無關。 */

export type Mods = { mul?: Record<string, number>, add?: Record<string, number> };

/** 收集所有來源的修正。M5 只有被動，M6 之後可能加進化與局外。 */
export type ModSource = () => Mods[];
var sources: ModSource[] = [];

export function registerModSource(fn: ModSource) { sources.push(fn); }
export function clearModSources() { sources.length = 0; }

/** 把一組修正套到 base 上，回傳新物件（不改動 base）。

    抽成獨立函式是為了讓**機庫的「換上這個部件會變怎樣」**能走同一條計算路徑
    （`ui/hangar-stats.ts`）。預覽若自己複製一份算法，兩邊遲早漂移，
    而漂移的症狀是「面板寫 +12% 但實際不是」—— 沒有任何測試會紅。 */
export function applyMods(base, list: Mods[]) {
  var mul: Record<string, number> = {}, add: Record<string, number> = {};
  for (var j = 0; j < list.length; j++) {
    var m = list[j];
    if (!m) continue;
    if (m.mul) for (var k in m.mul) mul[k] = (mul[k] === undefined ? 1 : mul[k]) * m.mul[k];
    if (m.add) for (var k2 in m.add) add[k2] = (add[k2] || 0) + m.add[k2];
  }
  var out: any = {};
  for (var key in base) {
    var v = base[key];
    if (mul[key] !== undefined) v *= mul[key];
    if (add[key] !== undefined) v += add[key];
    out[key] = v;
  }
  return out;
}

/** 重算 `P.s`。任何會改變修正的動作之後都要呼叫。 */
export function recalcStats() {
  if (!P.mech) return;
  var base = P.base || (P.base = baseStats(P.mech));
  var list: Mods[] = [];
  for (var i = 0; i < sources.length; i++) list = list.concat(sources[i]());
  P.s = applyMods(base, list);
}

/** 給升級介面用：某個欄位的「原始值 → 加成後」。 */
export function statPair(key) {
  var base = P.base ? P.base[key] : undefined;
  return { base: base, now: P.s ? P.s[key] : undefined };
}
